import { render, staticRenderFns } from "./interactiveanswerreply.vue?vue&type=template&id=9f996dba&scoped=true&"
import script from "./interactiveanswerreply.vue?vue&type=script&lang=js&"
export * from "./interactiveanswerreply.vue?vue&type=script&lang=js&"
import style0 from "./interactiveanswerreply.vue?vue&type=style&index=0&id=9f996dba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f996dba",
  null
  
)

export default component.exports